import { Injector } from "@angular/core";

export class ServiceLocator {
    static injector: Injector;
}



// WEBPACK FOOTER //
// ./src/vas/services/locator.service.ts